var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _polygon2, _path17, _path18, _circle4, _path19, _path20, _polygon3, _path21, _path22, _path23, _circle5, _circle6, _circle7, _rect, _path24, _rect2, _rect3, _path25, _rect4, _rect5, _path26, _rect6, _rect7, _path27, _rect8, _path28, _path29, _circle8, _circle9, _circle10, _path30, _path31, _path32, _polygon4, _path33, _polygon5, _path34, _circle11, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 762,
    height: 689.78723,
    viewBox: "0 0 762 689.78723",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M727.535,347.65423H472.69653a16.51867,16.51867,0,0,1-16.5-16.5V131.00043a12.10185,12.10185,0,0,1,12.08789-12.08838h263.4535A12.31111,12.31111,0,0,1,744.035,131.20941V331.15423A16.51866,16.51866,0,0,1,727.535,347.65423Z",
    transform: "translate(-219 -105.10638)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M488.69653,331.15423H711.535a16,16,0,0,0,16-16V161.60638a16,16,0,0,0-16-16H488.69653a16,16,0,0,0-16,16V315.15423A16,16,0,0,0,488.69653,331.15423Z",
    transform: "translate(-219 -105.10638)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M743.8053,130.05658H455.965v-8.40039a16.57376,16.57376,0,0,1,16.56-16.54981H727.24524a16.57369,16.57369,0,0,1,16.56006,16.54981Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.06033,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.31913,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.57794,
    cy: 12.5,
    r: 4.28342,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M505.09487,217.56238h-11.036a2.25988,2.25988,0,0,1-2.25737-2.25737V204.269a2.25987,2.25987,0,0,1,2.25737-2.25737h11.036a2.25988,2.25988,0,0,1,2.25737,2.25737v11.036A2.25989,2.25989,0,0,1,505.09487,217.56238Z",
    transform: "translate(-219 -105.10638)",
    fill: "#F4870F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M505.09487,246.15568h-11.036a2.25987,2.25987,0,0,1-2.25737-2.25737v-11.036a2.25987,2.25987,0,0,1,2.25737-2.25736h11.036a2.25988,2.25988,0,0,1,2.25737,2.25736v11.036A2.25988,2.25988,0,0,1,505.09487,246.15568Z",
    transform: "translate(-219 -105.10638)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M505.09487,274.749h-11.036a2.25987,2.25987,0,0,1-2.25737-2.25737v-11.036a2.25987,2.25987,0,0,1,2.25737-2.25737h11.036a2.25988,2.25988,0,0,1,2.25737,2.25737v11.036A2.25988,2.25988,0,0,1,505.09487,274.749Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M577.33059,212.04437H524.15707a2.25737,2.25737,0,0,1,0-4.51473h53.17352a2.25737,2.25737,0,1,1,0,4.51473Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M577.33059,240.63767H524.15707a2.25737,2.25737,0,0,1,0-4.51473h53.17352a2.25736,2.25736,0,1,1,0,4.51473Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M577.33059,269.231H524.15707a2.25737,2.25737,0,0,1,0-4.51473h53.17352a2.25737,2.25737,0,1,1,0,4.51473Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M708.34116,239.09724c.05671-.949.08892-1.90451.08892-2.86774a47.31775,47.31775,0,0,0-47.3177-47.3177v50.18544Z",
    transform: "translate(-219 -105.10638)",
    fill: "#F4870F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M657.5277,243.39885V193.21341a47.3177,47.3177,0,1,0,47.22879,50.18544Z",
    transform: "translate(-219 -105.10638)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M980,794.89362H220a1,1,0,0,1,0-2H980a1,1,0,0,1,0,2Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M723.69,518.032a10.70347,10.70347,0,0,1,.8898,1.43141l50.11327,5.63486,7.28838-9.84724,16.29888,9.05707L783.933,548.22754l-61.39551-16.11278A10.67269,10.67269,0,1,1,723.69,518.032Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M467.98716,505.09418a10.05572,10.05572,0,0,1-14.52487-5.17531l-35.72708.745,9.8976-15.71214,32.40963,1.70135a10.11027,10.11027,0,0,1,7.94472,18.44106Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M452.285,500.59644a4.509,4.509,0,0,1-4.42846,3.21337l-65.38677-1.66091-59.2065-17.52973a12.81886,12.81886,0,1,1,7.63274-24.47233l53.4904,17.53816,64.201,6.19566a4.52376,4.52376,0,0,1,4.06742,4.55554l-.18586,10.95078A4.52253,4.52253,0,0,1,452.285,500.59644Z",
    transform: "translate(-219 -105.10638)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "138.461 676.601 150.72 676.6 156.553 629.312 138.459 629.313 138.461 676.601",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M354.33347,777.70432l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53051.00146Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.461 676.601 114.72 676.6 120.553 629.312 102.459 629.313 102.461 676.601",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M318.33347,777.70432l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53051.00146Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.233,590.5992l2.92742,173.69393a4,4,0,0,0,4.36158,3.91617l14.34623-1.30421a4,4,0,0,0,3.62589-3.67442l8.39886-108.34524a1,1,0,0,1,1.99629.03943l4.19795,110.82575a4,4,0,0,0,3.99713,3.84859h15.38563a4,4,0,0,0,3.99255-3.756L387.233,589.5992l-64-16Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.65422,
    cy: 297.83534,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M386.29155,597.03866c-.02392,0-.04761-.001-.07153-.001l-57.43091-.88379a4.49951,4.49951,0,0,1-4.40845-4.05176l-.65014-6.50293a.50005.50005,0,0,0-.99512,0l-.67163,6.7168a4.49386,4.49386,0,0,1-4.13257,4.03809l-4.05859.3125a4.49944,4.49944,0,0,1-4.698-5.62793l3.49463-13.32422a181.54022,181.54022,0,0,0,1.69775-84.66016l-1.73657-7.89941a28.528,28.528,0,0,1,13.47021-30.81641l11.28028-6.6123,5.11792-7.67676a11.08482,11.08482,0,0,1,8.97754-4.92285c7.1394-.15625,19.38623,1.15137,21.68725,11.59082a28.50083,28.50083,0,0,1,19.282,27.44141l-1.65673,118.44238a4.50121,4.50121,0,0,1-4.49732,4.4375Z",
    transform: "translate(-219 -105.10638)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M357.733,417.0992c-.10071,3.472-2.51116,5.48066-5.47053,7.29925s-6.41876,2.60712-9.80794,3.36775a2.99863,2.99863,0,0,1-4.40516-2.62457l-3.1084-11.82324a74.84075,74.84075,0,0,1-2.39306-11.537c-.74861-7.50914,1.031-15.58706,6.27222-21.01633s14.33084-7.358,20.6116-3.17479c7.45361-9.51977,41.52344,11.513,33.11914,18.13282-1.49512,1.17767-3.78063-.31249-5.67841-.45693s-4.02454.18936-5.23,1.66218c-1.575,1.92421-.889,4.79052-1.538,7.1909a6.71433,6.71433,0,0,1-8.48369,4.34834,23.08891,23.08891,0,0,1-4.39987-2.82861c-1.45566-.96957-3.29506-1.686-4.93368-1.0745-2.15991.80607-2.92722,3.45041-3.12242,5.74756A53.23525,53.23525,0,0,1,357.733,417.0992Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.469 377.819 148.469 426.819 169.469 477.819 138.469 427.819 144.469 377.819",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M621.8191,751.2528,402.64859,621.22607a16.51868,16.51868,0,0,1-5.77178-22.60944L499.00167,426.477a12.10185,12.10185,0,0,1,16.56391-4.22883L742.14529,556.67053a12.31111,12.31111,0,0,1,4.30147,16.85056L644.42854,745.481A16.51868,16.51868,0,0,1,621.8191,751.2528Z",
    transform: "translate(-219 -105.10638)",
    fill: "#f2f2f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M424.828,615.19917,616.47734,728.89848a16,16,0,0,0,21.9243-5.59688l78.345-132.05681a16,16,0,0,0-5.59688-21.9243L519.50044,455.62118a16,16,0,0,0-21.9243,5.59688l-78.345,132.05681A16,16,0,0,0,424.828,615.19917Z",
    transform: "translate(-219 -105.10638)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M746.83739,572.4124,499.28409,425.54708l4.28615-7.22464a16.57377,16.57377,0,0,1,22.6865-5.784L745.32552,542.50484a16.57369,16.57369,0,0,1,5.798,22.68291Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.5197,
    cy: 325.08868,
    r: 4.28342,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.50287,
    cy: 333.38445,
    r: 4.28342,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.48604,
    cy: 341.68021,
    r: 4.28342,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 692.75326,
    y: 596.91526,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-394.35578 784.07411) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M685.786,594.57538l-5.69215-3.377.2786-.46961,5.69215,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.46961,5.69216,3.377Zm-11.38443-6.754-5.69216-3.377.27861-.46961,5.69215,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69216-3.377.27861-.46961,5.69215,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69216-3.377.27861-.46961,5.69215,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.46961,5.69216,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.4696,5.69215,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.4696,5.69216,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.4696,5.69215,3.377Zm-11.38442-6.754-5.69216-3.377.2786-.46961,5.69216,3.377Zm-11.38443-6.754-5.69227-3.377.2786-.46961,5.69227,3.377Zm-11.38443-6.754-5.69215-3.377.2786-.46961,5.69216,3.377Zm-11.38442-6.754-5.69227-3.377.2786-.46961,5.69227,3.377Z",
    transform: "translate(-219 -105.10638)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 502.09266,
    y: 483.80252,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-390.45414 564.69995) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 574.33054,
    y: 585.704,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-442.71335 676.73529) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M567.44766,583.41418,561.84,580.08734l.2786-.46961,5.60766,3.32684Zm-11.21531-6.65369-5.60766-3.32684.2786-.4696,5.60766,3.32684ZM545.017,570.10681,539.40937,566.78l.27861-.46961,5.60765,3.32684Zm-11.21531-6.65368-5.60766-3.32684.2786-.46961,5.60766,3.32684Zm-11.21532-6.65368-5.60777-3.32691.2786-.46961,5.60777,3.32691ZM511.371,550.1457l-5.60766-3.32684.2786-.46961,5.60766,3.32684ZM500.15565,543.492l-5.60766-3.32684.27861-.4696,5.60765,3.32684Zm-11.21532-6.65368-5.60765-3.32684.2786-.46961,5.60766,3.32684Z",
    transform: "translate(-219 -105.10638)",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 476.1826,
    y: 527.47601,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-440.70488 563.80623) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 507.12796,
    y: 573.77019,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-465.36353 613.09379) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M500.08342,571.38447l-5.76943-3.42282.2786-.4696,5.76943,3.42281Zm-11.539-6.8457L482.775,561.116l.27861-.46961,5.76943,3.42281Zm-11.53886-6.84563-5.76943-3.42281.27861-.46961,5.76943,3.42281Z",
    transform: "translate(-219 -105.10638)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 463.92407,
    y: 548.13874,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-464.47942 563.38339) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 486.20845,
    y: 609.03171,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-505.93544 612.37221) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M479.16391,606.646l-5.76943-3.42281.2786-.46961,5.76943,3.42281Zm-11.539-6.8457-5.76943-3.42281.2786-.46961,5.76943,3.42282Zm-11.53886-6.84563-5.76943-3.42281.2786-.46961,5.76943,3.42282Z",
    transform: "translate(-219 -105.10638)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 443.00457,
    y: 583.40025,
    width: 0.54603,
    height: 3.27619,
    transform: "translate(-505.05132 562.6618) rotate(-59.32072)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M457.40154,594.22223l162.40985,96.35248a17.26548,17.26548,0,0,0,23.63179-6.03277l47.45331-79.98636-.32653-.18123L582.90466,631.8558l-8.52852-33.39355a4.1237,4.1237,0,0,0-2.3875-2.787,4.39388,4.39388,0,0,0-2.81786-.15814l-56.42137,14.39926-6.23665-24.41473a4.13956,4.13956,0,0,0-5.03644-2.988C501.09523,582.61466,464.381,592.34258,457.40154,594.22223Z",
    transform: "translate(-219 -105.10638)",
    fill: "#F4870F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M456.43081,594.28059l-.135-.529,45.14944-11.52584a4.646,4.646,0,0,1,5.64492,3.349l6.11019,23.935,56.10809-14.32339a4.646,4.646,0,0,1,5.64492,3.349l8.40225,32.91358,108.226-27.62815.135.529-108.755,27.76319-8.53729-33.44258a4.095,4.095,0,0,0-4.98086-2.955l-56.6371,14.45843-6.24524-24.46406a4.10019,4.10019,0,0,0-4.98086-2.955Z",
    transform: "translate(-219 -105.10638)",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.80979,
    cy: 471.13771,
    r: 3.82222,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.01238,
    cy: 483.07152,
    r: 3.82222,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.09156,
    cy: 492.27639,
    r: 3.82222,
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M393.37946,601.9174a10.05579,10.05579,0,0,1-.31761-15.41606l-13.37856-33.136,18.20228,3.67571,9.9139,30.903a10.11027,10.11027,0,0,1-14.42,13.97336Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ffb8b8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M393.1576,587.56063a4.50906,4.50906,0,0,1-4.57608-2.99942L366.92391,522.843l-4.62838-61.57336a12.81886,12.81886,0,1,1,25.588-1.55128l2.59146,56.23251,16.99724,62.21933a4.52375,4.52375,0,0,1-2.81506,5.41961l-10.30361,3.71344A4.52237,4.52237,0,0,1,393.1576,587.56063Z",
    transform: "translate(-219 -105.10638)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M794.719,532.87451a4.58959,4.58959,0,0,1-1.11619-.69655l-20.14091-16.9666a4.57512,4.57512,0,0,1-.29423-6.72835l18.27677-18.35229a4.5519,4.5519,0,0,1,5.93049-.47235L811.19646,499.695a4.57786,4.57786,0,0,1,1.448,5.65826l-11.957,25.28131a4.57994,4.57994,0,0,1-5.96851,2.23991Z",
    transform: "translate(-219 -105.10638)",
    fill: "#F4870F"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "654.276 667.73 642.247 671.003 623.898 626.162 641.652 621.332 654.276 667.73",
    fill: "#ffb8b8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M853.29972,773.57564H877.593a0,0,0,0,1,0,0v15.13777a0,0,0,0,1,0,0H838.41287a0,0,0,0,1,0,0v-.25092A14.88686,14.88686,0,0,1,853.29972,773.57564Z",
    transform: "translate(-393.98241 147.55249) rotate(-15.22067)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "551.441 676.909 538.975 676.908 533.044 628.823 551.444 628.824 551.441 676.909",
    fill: "#ffb8b8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M529.81942,673.346h24.29327a0,0,0,0,1,0,0v15.13777a0,0,0,0,1,0,0H514.93256a0,0,0,0,1,0,0v-.25092A14.88686,14.88686,0,0,1,529.81942,673.346Z",
    fill: "#2f2e41"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.22114,
    cy: 334.4528,
    r: 24.97498,
    fill: "#ffb8b8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M769.67811,747.73077h-17.036a4.58914,4.58914,0,0,1-4.57138-4.29382c-5.07632-80.69888-2.10694-138.58608,9.34458-182.17277a4.75677,4.75677,0,0,1,.18545-.56105l.91234-2.281a4.55426,4.55426,0,0,1,4.24889-2.87679h35.03255a4.56841,4.56841,0,0,1,3.47434,1.59778l4.75831,5.552c.09284.10824.17973.21846.2634.33465,21.45671,29.92172,40.68557,88.41962,62.95582,167.04706a4.5605,4.5605,0,0,1-3.00836,5.60957l-18.30834,5.85883a4.60045,4.60045,0,0,1-5.51648-2.37133l-47.51012-98.5405a3.55918,3.55918,0,0,0-6.73194,1.06353l-13.9594,102.07763A4.59333,4.59333,0,0,1,769.67811,747.73077Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M804.10666,563.10127c-.04791,0-.09558-.001-.14374-.002l-42.5537-1.34356a4.561,4.561,0,0,1-4.40156-4.02074c-5.39434-43.66514,9.39994-55.36293,16.011-58.36484a3.51794,3.51794,0,0,0,2.04612-2.7894l.572-4.57683a4.55913,4.55913,0,0,1,.90414-2.22238c10.36541-13.42764,24.51919-17.72742,32.03363-19.09481a4.56882,4.56882,0,0,1,5.33973,3.91449l.857,6.57181a3.62041,3.62041,0,0,0,.7254,1.71992c21.61733,28.26039-2.46543,69.98715-7.51271,78.06439h0A4.58439,4.58439,0,0,1,804.10666,563.10127Z",
    transform: "translate(-219 -105.10638)",
    fill: "#F4870F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M816.7,424.02666a103.57206,103.57206,0,0,1-4.09287-17.25254c-.273-3.41006.60057-7.07923,3.08395-9.43206,4.64755-4.40323,12.54378-2.306,17.40406,1.86121,7.02423,6.02258,10.52747,15.27806,11.85143,24.43548s.74144,18.46957,1.06013,27.71671,1.64124,18.75534,6.35559,26.71687,13.46275,14.07278,22.69054,13.39517a15.969,15.969,0,0,0,9.9964-4.23637,11.591,11.591,0,0,0,3.48119-10.06508c4.71642,8.44535,2.32556,19.89152-4.70938,26.53065s-17.856,8.51593-27.10448,5.68134-16.86021-9.94222-21.4068-18.4802-6.2127-18.40091-5.97125-28.071c.18542-7.42586,1.4477-14.91251.19284-22.23392s-5.837-14.75531-13.0623-16.4794Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M784.25282,433.65235c-1.23189,4.11515-5.94388,6.65267-10.18271,5.95671a11.94052,11.94052,0,0,1-9.01247-8.28474,17.05556,17.05556,0,0,1,1.3329-12.50345,19.47082,19.47082,0,0,1,11.14084-9.92334,15.98674,15.98674,0,0,1,14.53656,2.32276,5.3461,5.3461,0,0,1,3.736-3.907,10.21608,10.21608,0,0,1,5.60645.08275,23.10023,23.10023,0,0,1,12.857,9.35333A37.59027,37.59027,0,0,1,820.0944,431.77c1.43448,8.05189.90537,16.85038-3.61682,23.6651s-13.774,10.83861-21.27971,7.58968c-.468-2.39261.6407-4.80178,1.92341-6.875s2.80291-4.09289,3.29567-6.48052-.45191-5.30818-2.76144-6.089c-1.9703-.66614-4.071.4131-6.14677.54342a6.73548,6.73548,0,0,1-6.461-9.70517Z",
    transform: "translate(-219 -105.10638)",
    fill: "#2f2e41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M720.95558,536.53977a10.7034,10.7034,0,0,1,1.14367,1.238l50.27705-3.9129,5.30143-11.04461,17.714,5.82223-9.58111,26.19523-63.33219-4.25038a10.67269,10.67269,0,1,1-1.52285-14.04759Z",
    transform: "translate(-219 -105.10638)",
    fill: "#ffb8b8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M795.11921,546.09046a4.58982,4.58982,0,0,1-1.2007-.53793L771.65332,531.489a4.57513,4.57513,0,0,1-1.20841-6.62549l15.60522-20.6718a4.5519,4.5519,0,0,1,5.81079-1.27615l15.06041,8.05944a4.57784,4.57784,0,0,1,2.20564,5.40813l-8.40018,26.67494a4.57994,4.57994,0,0,1-5.60758,3.03239Z",
    transform: "translate(-219 -105.10638)",
    fill: "#F4870F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingWelcome);
export default __webpack_public_path__ + "static/media/onboarding-welcome.fcb407c05c5fa1c469c96e55bbb2cd5b.svg";
export { ForwardRef as ReactComponent };